/* Persona sport deck.
   Pins the sport sections in place and cross-fades between them as you scroll.
   A tall track supplies the scroll distance; a sticky stage holds the viewport
   still. Native scrolling drives it, so the page is never scroll-jacked and it
   releases normally at both ends. */
(function () {
  if (window.__personaSportDeck) return;
  window.__personaSportDeck = true;

  var OFFSET = 48;
  var track = null;
  var stage = null;
  var slides = [];
  var index = -1;
  var ticking = false;

  function vh() {
    return window.innerHeight;
  }

  function build() {
    // Move the whole `.shopify-section` wrapper, not the inner marked div:
    // the section's own CSS is scoped to `#shopify-section-…`, so lifting the
    // inner div out of that wrapper would strip its background and chrome.
    var found = [].slice
      .call(document.querySelectorAll('[data-sport-section]'))
      .map(function (el) {
        return el.closest('.shopify-section') || el;
      });
    if (found.length < 2) return false;

    if (found[0].parentNode && found[0].parentNode.classList.contains('sport-deck-stage')) {
      stage = found[0].parentNode;
      track = stage.parentNode;
      slides = found;
      return true;
    }

    // A hot reload re-inserts sections at their original position, orphaning any
    // deck built earlier. Clear those out before building a fresh one.
    [].slice.call(document.querySelectorAll('.sport-deck-track')).forEach(function (old) {
      if (old.parentNode) old.parentNode.removeChild(old);
    });

    track = document.createElement('div');
    track.className = 'sport-deck-track';
    stage = document.createElement('div');
    stage.className = 'sport-deck-stage';
    track.appendChild(stage);
    found[0].parentNode.insertBefore(track, found[0]);
    found.forEach(function (slide) {
      stage.appendChild(slide);
      slide.classList.add('sport-slide');
    });
    slides = found;
    return true;
  }

  function layout() {
    if (!track) return;
    // One viewport of scroll per sport: the last one still gets a full screen.
    track.style.height = slides.length * vh() + 'px';
  }

  function paint(next) {
    if (next === index) return;
    var dir = index === -1 || next > index ? 'next' : 'prev';
    var previous = slides[index];
    var incoming = slides[next];
    index = next;

    if (previous && previous !== incoming) {
      previous.classList.remove('is-active');
      previous.setAttribute('aria-hidden', 'true');
      previous.style.transform = 'translateY(' + (dir === 'next' ? -OFFSET : OFFSET) + 'px)';
    }

    if (incoming) {
      incoming.style.transition = 'none';
      incoming.style.transform = 'translateY(' + (dir === 'next' ? OFFSET : -OFFSET) + 'px)';
      void incoming.offsetHeight; // force reflow so the reset is not animated
      incoming.style.transition = '';
      incoming.style.transform = '';
      incoming.classList.add('is-active');
      incoming.setAttribute('aria-hidden', 'false');
    }

    trimArrows();
  }

  // Hide the up arrow on the first sport and the down arrow on the last.
  function trimArrows() {
    slides.forEach(function (slide, i) {
      slide.querySelectorAll('.sport-nav--up').forEach(function (b) {
        b.hidden = i === 0;
      });
      slide.querySelectorAll('.sport-nav--down').forEach(function (b) {
        b.hidden = i === slides.length - 1;
      });
    });
  }

  function topFor(i) {
    return track.offsetTop + i * vh();
  }

  function fromScroll() {
    if (!track) return;
    var progress = (window.pageYOffset - track.offsetTop) / vh();
    var next = Math.round(progress);
    if (next < 0) next = 0;
    if (next > slides.length - 1) next = slides.length - 1;
    paint(next);
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      fromScroll();
      ticking = false;
    });
  }

  function goTo(i) {
    if (i < 0 || i > slides.length - 1) return;
    window.scrollTo({ top: topFor(i), behavior: 'smooth' });
  }

  function onClick(event) {
    var button = event.target.closest('[data-sport-nav]');
    if (!button || !stage || !stage.contains(button)) return;
    event.preventDefault();
    goTo(button.getAttribute('data-sport-nav') === 'next' ? index + 1 : index - 1);
  }

  function init() {
    if (!build()) return;
    layout();
    fromScroll();
    if (index === -1) paint(0);

    document.addEventListener('click', onClick);
    window.addEventListener('scroll', onScroll, { passive: true });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        layout();
        fromScroll();
      }, 150);
    });

    // Theme-editor edits and dev hot reloads re-insert sections outside the
    // deck; rebuild so the stack survives without a manual refresh.
    var rebuildTimer;
    var rebuild = function () {
      clearTimeout(rebuildTimer);
      rebuildTimer = setTimeout(function () {
        track = null;
        stage = null;
        slides = [];
        index = -1;
        if (build()) {
          layout();
          fromScroll();
          if (index === -1) paint(0);
        }
      }, 60);
    };

    document.addEventListener('shopify:section:load', rebuild);
    document.addEventListener('shopify:section:unload', rebuild);

    // Catch dev-server hot reloads, which do not fire Shopify's section events.
    if (window.MutationObserver) {
      new MutationObserver(function () {
        var marked = document.querySelectorAll('[data-sport-section]');
        if (!marked.length) return;
        var first = marked[0].closest('.shopify-section') || marked[0];
        if (!first.parentNode || !first.parentNode.classList.contains('sport-deck-stage')) {
          rebuild();
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
